<script setup>
import { computed } from 'vue';
import { trans } from '@elements/translation';

const props = defineProps({
  modelValue: { type: Number, default: null },
  error: { type: String, default: null },
  validationRules: { type: Object, required: true },
});

const emit = defineEmits([ 'update:modelValue' ]);

const commonSurface = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value === '' ? null : value),
});
</script>

<template>
  <div class="content-form__field form-field">
    <label
      class="form-field__label field-label"
      for="common_surface"
    >
      <span>{{ trans('addresses.details.form.field.common_surface.label') }}</span>
    </label>
    <div class="form-field__input field-input field-input--small input-text input-text--legend">
      <input
        id="common_surface"
        v-model.number="commonSurface"
        type="number"
        :min="validationRules.min"
        :max="validationRules.max"
        name="common_surface"
        :class="{ error: error !== null }"
        placeholder="0"
        @focusout="$emit('focusout')"
      >
      <span>{{ trans('global.area_unit.MTK') }}</span>
    </div>
    <span v-if="error" class="form-field__error">
      {{ error }}
    </span>
  </div>
</template>
